<div class="fluid grid">
  <div class="field col-12">
    <label for="DC1">{{condLable}}</label>
    <p-autoComplete id="DC1"
                    [(ngModel)]="deliveryConditionsResult"
                    [suggestions]="suggestDeliveryConditions"
                    [dropdown]="true"
                    [multiple]="true"
                    emptyMessage="Нет подходящих условий для выбора"
                    placeholder="Укажите условия отгрузки и оплаты"
                    (completeMethod)="searchDeliveryOptions($event)"
                    (onSelect)="onSelectDeliveryOptions($event)"
                    (onUnselect)="onUnselectDeliveryOptions($event)"
                    (onDropdownClick)="onDropdownClickDeliveryOptions($event)"
                    (onClear)="onClearDeliveryOptions($event)"></p-autoComplete>
  </div>
  <div class="field col-12">
    <label for="DN1">{{sNoteLable}}</label>
    <input id="DN1" type="text" pInputText [(ngModel)]="newDocument.DOCNOTE1" value="newDocument.DOCNOTE1" />
  </div>
  <div class="field col-12">
    <label for="DN2">{{bNoteLable}}</label>
    <input id="DN2" type="text" pInputText [(ngModel)]="newDocument.DOCNOTE2" value="newDocument.DOCNOTE1" />
  </div>
</div>
